// Transfer Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get transferList from backend then update transferList in vuex store ***** //
export const updateTransferList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('transfer_index', { params: params })
    commit('updateTransferList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch Transfer from backend ***** //
export const fetchTransferInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`transfer_show/${payload}`)
    commit('fetchTransferInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add Transfer  ***** //
export const addTransfer = async (ignored, payload = null) => {
  try {
    await Axios.post('transfer_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update Transfer  info ***** //
export const updateTransferInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`transfer_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete Transfer  ***** //
export const deleteTransfer = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`transfer_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}

// ***** Fetch transfers products list from backend ***** //
export const fetchTransferProductsList = async ({ commit }) => {
  let productsList = []

  try {
    const result = await Axios.get('transfer_products_list')
    result.data.data.forEach(purchaseProduct => {
      productsList.push({
        value: purchaseProduct.product_id,
        text: purchaseProduct.product_name_with_quantity,
        collections: purchaseProduct.collections
      })
    })
    commit('fetchTransferProductsList', productsList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch PendingTransferCount from backend ***** //
export const fetchPendingTransferCount = async ({ commit }) => {
  try {
    const result = await Axios.get(`transfer_pending_alarm`)
    commit('fetchPendingTransferCount', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Approve Transfer from backend ***** //
export const approveTransfer = async (ignored, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`transfer_approve/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Approve Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, approving transfers failed')
  }
}

// ***** DisApprove Transfer from backend ***** //
export const disapproveTransfer = async (ignored, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.get(`transfer_disapprove/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Disapprove Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, disapproving transfers failed')
  }
}

export const setTransferOutletsList = async ({ commit }) => {
  let transferOutletsList = []

  try {
    const result = await Axios.get('transfer_outlets_list')
    result.data.data.forEach(vender => {
      transferOutletsList.push({
        value: vender.outlet_id,
        text: vender.outlet_name
      })
    })
    commit('setTransferOutletsList', transferOutletsList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
